
import React, { useState, useEffect, useRef } from 'react';
import logog20 from './landingpageimages/g20newlogo.png';
import logogov from './landingpageimages/govofindia.jpeg';
import image1 from './landingpageimages/image11.png';
import image2 from './landingpageimages/image12.png';
import image3 from './landingpageimages/image13.png';
import Chancellor from './landingpageimages/cpradhakrishna.png';
import vc from './landingpageimages/member-2.jpg';
import villas from './landingpageimages/member-3.jpg';
import naaclogo from './landingpageimages/naac.png';
import mou from './landingpageimages/mou.png';
import phd from './landingpageimages/phd.png';
import work from './landingpageimages/workshop.png';
import nad from './landingpageimages/nad.png';
import edu from './landingpageimages/edu.png';
import bank from './landingpageimages/bank.png';
import nep from'./landingpageimages/nep.png';
import msme from './landingpageimages/msme.png';
import education from './landingpageimages/education.png';
import sameer from './landingpageimages/sameer.png';
import tifr from './landingpageimages/tifr.png';
import met from './landingpageimages/met.png';
import skill from './landingpageimages/skillindia.png';
import pmvy from './landingpageimages/pmvy.png';
import life from './landingpageimages/life.png';
import bse from './landingpageimages/bse.png';
import kahoot from './landingpageimages/kahoot.png';
import tree from './landingpageimages/tree.jpg';
import sci from './landingpageimages/sci.jpg';
import comm from './landingpageimages/commer.jpg';
import human from './landingpageimages/human.jpg';
import study from './landingpageimages/study.jpg';
import Contactus from './Contactus';
import Aboutus from './Aboutus';

import skillsbg from './landingpageimages/skillsbg.jpeg';
import nepnewlogo from './landingpageimages/nepnewlogo.png';
import mahadev from './landingpageimages/Mahadev.jpg';
import gopal from './landingpageimages/Gopal.jpg';
import keshav from './landingpageimages/Keshav.jpg';
import ramkrushna from'./landingpageimages/Ramkrishna.jpg';
import tilak from './landingpageimages/Tilak.jpg';
import justice from './landingpageimages/Justice.jpg';
import Presentation1044 from './landingpageimages/Presentation1044.jpg';
import womens from './landingpageimages/womens-day1.jpg';
import Presentation105 from './landingpageimages/Presentation105.jpg';
import gather from './landingpageimages/gather.jpeg';
import { motion, AnimatePresence } from "framer-motion";
import TdtlLogo from './landingpageimages/thedatalablogo.jpeg';
import { Link } from 'react-router-dom';
import tdtlpage from './landingpageimages/tdtlbranding.png';
import TdtlBaner from './landingpageimages/baner1.png';
import Elephanttank from './landingpageimages/elephanttank.jpg';
import Elephanttank2 from './landingpageimages/elephanttank2.jpg';
import { useNavigate } from 'react-router-dom';
import amit from './landingpageimages/amitsir.jpg';


// Main App Component
function App() {

  
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
    useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    
  const [activeSlide, setActiveSlide] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeNewsTab, setActiveNewsTab] = useState('Students');
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState({});
  const [currentAlumniPage, setCurrentAlumniPage] = useState(0);
  const [currentFactsPage, setCurrentFactsPage] = useState(0);
  const images = [womens, Presentation105,TdtlBaner,Elephanttank,Elephanttank2, gather, Presentation1044];
  
  
  // Refs for scroll animations
  const featuresRef = useRef(null);
  const partnershipsRef = useRef(null);
  const curriculumRef = useRef(null);
  const skillsRef = useRef(null);
  const alumniRef = useRef(null);
  const nepRef = useRef(null);
  const academicsRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
const navigate = useNavigate(); 


const [index, setIndex] = useState(1); 
  const [transition, setTransition] = useState(true);

  // Clone first and last slide for seamless looping
  const extendedImages = [images[images.length - 1], ...images, images[0]];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => prevIndex + 1);
    }, 3000); // Adjust the speed as needed

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (index === extendedImages.length - 1) {
      setTimeout(() => {
        setTransition(false);
        setIndex(1); // Jump to real first slide
      }, 1000); // Delay must match CSS transition duration
    } else if (index === 0) {
      setTimeout(() => {
        setTransition(false);
        setIndex(extendedImages.length - 2); // Jump to real last slide
      }, 1000);
    } else {
      setTransition(true);
    }
  }, [index, extendedImages.length]);


  //endof slideshow

useEffect(() => {
  const timer = setTimeout(() => {
    setShowPopup(true);
  }, 5000); // 5 seconds
  return () => clearTimeout(timer);
}, []);

  // Handle scroll for animations
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      
      // Check if elements are in viewport
      const isInViewport = (element) => {
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8 &&
          rect.bottom >= 0
        );
      };
      
      // Set visibility for animations
      setIsVisible({
        features: isInViewport(featuresRef.current),
        partnerships: isInViewport(partnershipsRef.current),
        curriculum: isInViewport(curriculumRef.current),
        skills: isInViewport(skillsRef.current),
        alumni: isInViewport(alumniRef.current),
        nep: isInViewport(nepRef.current),
        academics: isInViewport(academicsRef.current)
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    
    // Auto-rotate news slides
    const newsInterval = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % 3);
    }, 5000);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearInterval(newsInterval);
    };
  }, []);
  
  
  // News data
  const newsItems = [
    {
      date: 'JUN 20',
      title: 'M.Sc. Biotechnology Provisional Merit List, 2024-25',
      isNew: true,
      link: '#'
    },
    {
      date: 'JUN 20',
      title: 'M.Sc. Bioinformatics Provisional Merit List, 2024-25',
      isNew: true,
      link: '#'
    },
    {
      date: 'JUN 20',
      title: 'M.Sc. Biochemistry Provisional Merit List, 2024-25',
      isNew: true,
      link: '#'
    },
    {
      date: 'JUN 20',
      title: 'M.Sc. Botany Provisional Merit List, 2024-25',
      isNew: true,
      link: '#'
    },
    {
      date: 'JUN 20',
      title: 'M.Sc. Chemistry Provisional Merit List, 2024-25',
      isNew: true,
      link: '#'
    }
  ];
  
  // Features data
  const features = [
    {
      id: 'naac',
      title: 'NAAC',
      image: naaclogo,
    },
    {
      id: 'mous',
      title: 'MoUs',
      image: mou,
    },
    {
      id: 'phd',
      title: 'Ph.D. Thesis',
      image: phd
    },
    {
      id: 'workshops',
      title: 'Workshops / Seminars',
      image: work
    },
    {
      id: 'nad',
      title: 'NAD',
      image: nad
    },
    {
      id: 'edureform',
      title: 'EDUREFORM',
      image: edu
    },
    {
      id: 'academic-bank',
      title: 'Academic Bank Of Credits',
      image: bank
    },
    {
      id: 'nep',
      title: 'NEP 2020',
      image: nep
    }
  ];
  
  // Partners data
  const partners = [
    { id: 'msme', logo:msme },
    { id: 'education', logo: education },
    { id: 'sameer', logo: sameer },
    { id: 'tifr', logo: tifr },
    { id: 'met', logo: met },
    { id: 'skill-india', logo: skill },
    { id: 'pmkvy', logo: pmvy },
    { id: 'life', logo: life },
    { id: 'bse', logo: bse},
    { id: 'kahoot', logo: kahoot }
  ];
  
  // Curriculum items
  const curriculumItems = [
    { title: 'Honors Programs', icon: '➤' },
    { title: 'Internships & Co-op Programs', icon: '➤' },
    { title: 'Study Abroad Programs', icon: '➤' },
    { title: 'Service-Learning Initiatives', icon: '➤' },
    { title: 'Interdisciplinary Courses', icon: '➤' },
    { title: 'Leadership Development Programs', icon: '➤' },
    { title: 'Mentorship Programs', icon: '➤' },
    { title: 'Health & Wellness Programs', icon: '➤' },
    { title: 'Research & Innovation Initiatives', icon: '➤' },
    { title: 'Financial Literacy Programs', icon: '➤' },
    { title: 'Capstone Projects', icon: '➤' },
    { title: 'Industry Partnerships', icon: '➤' },
    { title: 'Entrepreneurship Programs', icon: '➤' },
    { title: 'Technology Integration', icon: '➤' },
    { title: 'Career counselling services', icon: '➤' }
  ];
  
  // Academic categories
  const academicCategories = [
    {
      id: 'science',
      title: 'Science & Technology',
      image: sci
    },
    {
      id: 'commerce',
      title: 'Commerce & Management',
      image: comm
    },
    {
      id: 'humanities',
      title: 'Humanities & Social Sciences',
      image: human
    },
    {
      id: 'interdisciplinary',
      title: 'Interdisciplinary Studies',
      image: study
    }
  ];
  
  // Skill development data
  const skillDevelopment = [
    { id: 'fundings', title: 'Fundings' },
    { id: 'industry', title: 'Industry Partnership & CSR' },
    { id: 'training', title: 'Training Centre' },
    { id: 'design', title: 'Design' },
    { id: 'development', title: 'Development' },
    { id: 'marketing', title: 'Marketing' },
    { id: 'it', title: 'IT & Software' },
    { id: 'impact', title: 'Skill Impact Bond' }
  ];
  
  // NEP benefits
  const nepBenefits = [
    {
      id: 'academic-programs',
      title: 'Academic programs with credit transfer',
      icon: '🏛️'
    },
    {
      id: 'holistic-skills',
      title: 'Holistic skills integration',
      icon: '🌸'
    },
    {
      id: 'technology',
      title: 'Technology mediated teaching - learning',
      icon: '💻'
    },
    {
      id: 'job-ready',
      title: 'Job-ready programs in partnership with corporates & industries',
      icon: '🎓'
    },
    {
      id: 'partnerships',
      title: 'Partnerships with research institutes of national importance',
      icon: '🤝'
    },
    {
      id: 'internship',
      title: 'Internship portal for connecting with MSME',
      icon: '💼'
    }
  ];
  
  // Alumni data
  const alumni = [
    { id: 'alumni1', image: mahadev, name: 'Mahadev Govind Ranade' },
    { id: 'alumni2', image: gopal, name: 'Gopal Krishna Gokhale' },
    { id: 'alumni3', image:keshav, name: 'Keshav Karne' },
    { id: 'alumni4', image: ramkrushna, name: 'Ramkrishna Gopal Bhandarkar' },
    { id: 'alumni5', image: tilak, name: 'Tilak' },
    { id: 'alumni6', image:justice, name: 'Justice Sujata V Manohar' },
    // { id: 'alumni7', image: 'https://placehold.co/200x250?text=Alumni+7', name: 'Dr. B.R. Ambedkar' },
    // { id: 'alumni8', image: 'https://placehold.co/200x250?text=Alumni+8', name: 'Pherozeshah Mehta' },
    // { id: 'alumni9', image: 'https://placehold.co/200x250?text=Alumni+9', name: 'Jamsetji Tata' },
    // { id: 'alumni10', image: 'https://placehold.co/200x250?text=Alumni+10', name: 'Homi Jehangir Bhabha' },
    // { id: 'alumni11', image: 'https://placehold.co/200x250?text=Alumni+11', name: 'Bhulabhai Desai' }
  ];
  
  // Facts data
  const facts = [
    {
      id: 'fact1',
      image: image1,
      title: 'Cluster of four NAAC \'A\' grade constituent colleges'
    },
    {
      id: 'fact2',
      image: image2,
      title: 'First cluster university of Government of Maharashtra, established in 2019'
    },
    {
      id: 'fact3',
      image: image3,
      title: 'Cluster of four NAAC \'A\' grade constituent colleges'
    }
  ];
  
  // Constituent colleges
  const colleges = [
    {
      name: 'Institute Of Science',
      logo: 'https://placehold.co/100x100?text=IOS'
    },
    {
      name: 'Sydenham College',
      logo: 'https://placehold.co/100x100?text=Sydenham'
    },
    {
      name: 'Elphinstone College',
      logo: 'https://placehold.co/100x100?text=Elphinstone'
    },
    {
      name: 'Secondary Training College',
      logo: 'https://placehold.co/100x100?text=STC'
    },
    {
      name: 'SIMSREE',
      logo: 'https://placehold.co/100x100?text=SIMSREE'
    },
    {
      name: 'Institute Of Forensic Science',
      logo: 'https://placehold.co/100x100?text=IFS'
    }
  ];
  
  // Leadership team
  const leadership = [
    {
      name: 'Shri C. P. Radhakrishnan',
      title: 'Hon\'ble Chancellor',
      image: Chancellor,
    },
    {
      name: 'Prof. Rajanish Kamalakar Kamat',
      title: 'Hon\'ble Vice-Chancellor',
      image: vc
    },
    // {
    //   name: 'Prof. Vilas Padhye',
    //   title: 'Registrar',
    //   image: villas
    // },
    {
      name: 'Dr. Amit Andre',
      title: 'Industry Expert',
      image: amit
    },

  ];
  const [isTickerPaused, setIsTickerPaused] = useState(false);

  // Styles
  const styles = {
    // General styles
    body: {
      margin: 0,
      padding: 0,
      fontFamily: 'Arial, sans-serif',
      overflowX: 'hidden'
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 15px'
    },
    section: {
      padding: '40px 0'
    },
    sectionTitle: {
      color: '#8b1650',
      fontSize: '32px',
      fontWeight: 'bold',
      textAlign: 'center',
      margin: '0 0 30px 0'
    },
    flexRow: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    flexBetween: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    button: {
      backgroundColor: '#8b1650',
      color: 'white',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: 'bold',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s ease'
    },
    
    // Header styles
    topBar: {
      backgroundColor: '#f5f5f5',
      padding: '5px 0',
      borderBottom: '1px solid #e0e0e0'
    },
    topBarContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    topBarLeft: {
      display: 'flex',
      alignItems: 'center'
    },
    topBarRight: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    },
    header: {
      backgroundColor: 'white',
      padding: windowWidth > 1024 ? '20px 40px' : windowWidth > 768 ? '15px 20px' : '10px 10px',
      borderBottom: '1px solid #e0e0e0',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    },
    headerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '10px'
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      flexWrap: 'wrap'
    },
    logoImage: {
      height: windowWidth < 600 ? '50px' : '80px',
      width: 'auto'
    },
    logoText: {
      color: '#003087',
      fontSize: windowWidth < 600 ? '16px' : '24px',
      fontWeight: 'bold',
      lineHeight: '1.2',
      display: windowWidth < 768 ? 'none' : 'block'
    },
    mobileMenuButton: {
      fontSize: '24px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      display: windowWidth < 768 ? 'block' : 'none'
    },
    nav: {
      display: 'flex'
    },
    navLink: {
      padding: '10px 15px',
      color: '#333',
      textDecoration: 'none',
      fontWeight: '500',
      fontSize: '14px',
      transition: 'color 0.3s ease'
    },
    navLinkHover: {
      color: '#8b1650'
    },
    mobileMenuButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      display: 'none',
      fontSize: '24px'
    },
    mobileMenu: {
      display: 'none',
      position: 'fixed',
      top: '60px',
      left: 0,
      right: 0,
      backgroundColor: 'white',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      zIndex: 999
    },
    
    // News ticker
    newsTicker: {
      backgroundColor: '#8b1650',
      color: 'white',
      padding: '10px 0',
      overflow: 'hidden'
    },
    newsTickerContent: {
      display: 'flex',
      alignItems: 'center'
    },
    newsTickerLabel: {
      backgroundColor: '#ffc107',
      color: '#333',
      padding: '5px 15px',
      fontWeight: 'bold',
      marginRight: '15px',
      whiteSpace: 'nowrap'
    },
    newsTickerItems: {
      display: 'flex',
      alignItems: 'center',
      animation: 'ticker 20s linear infinite',
      whiteSpace: 'nowrap'
    },
    newsTickerItem: {
      marginRight: '30px',
      fontWeight:'700'
    },
    newsTickerControls: {
      display: 'flex',
      marginLeft: 'auto'
    },
    newsTickerControl: {
      background: 'none',
      border: 'none',
      color: 'white',
      cursor: 'pointer',
      fontSize: '16px',
      padding: '0 5px'
    },
    newsTickerScrollWrapper: {
      flex: 1,
      overflow: 'hidden'
    },
    newsTickerItems: (isPaused) => ({
      display: 'inline-flex',
      animation: isPaused ? 'none' : 'ticker 20s linear infinite',
      whiteSpace: 'nowrap'
    }),
    
    
    
    // Hero slider
    sliderContainer: {
      width: "100vw",
      height: "600px",
      overflow: "hidden",
      position: "relative",
    },
    sliderWrapper: {
      display: "flex",
      width: "300%", // 3 slides * 100%
      transition: "transform 3s ease-in-out",
    },
    slide: {
      minWidth: "100vw",
      height: "600px",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
    },
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay for readability
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    heroSlider: {
      position: 'relative',
      height: '600px',
      overflow: "hidden",
      // overflow: 'hidden'
    },
    heroSlide: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      // opacity: 0,
      transition: 'opacity 1s ease',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    heroSlideActive: {
      opacity: 1
    },
    heroContent: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: "center",
      color: "white",
      width: "80%",
      maxWidth: "800px",
      padding: "20px",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      borderRadius: "8px",
    },
    heroTitle: {
      fontSize: '36px',
      fontWeight: 'bold',
      marginBottom: '15px'
    },
    heroSubtitle: {
      fontSize: '18px',
      marginBottom: '20px'
    },
    
    // Features section
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
      gap: '20px'
    },
    featureCard: {
      border: '1px solid #e0e0e0',
      borderRadius: '4px',
      overflow: 'hidden',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      backgroundColor: 'white'
    },
    featureCardHover: {
      transform: 'translateY(-5px)',
      boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)'
    },
    featureImage: {
      width: '100%',
      height: '180px',
      objectFit: 'cover'
    },
    featureTitle: {
      padding: '15px',
      textAlign: 'center',
      fontWeight: 'bold'
    },
    
    // Partners section
    partnersGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
      gap: '30px',
      alignItems: 'center',
      justifyItems: 'center'
    },
    partnerLogo: {
      maxWidth: '100%',
      height: 'auto',
      transition: 'transform 0.3s ease'
    },
    partnerLogoHover: {
      transform: 'scale(1.1)'
    },
    
    // Curriculum section
    curriculumContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    curriculumDescription: {
      maxWidth: '800px',
      textAlign: 'center',
      marginBottom: '40px',
      fontSize: '18px',
      lineHeight: '1.6'
    },
    curriculumContent: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      gap: '20px'
    },
    curriculumLeft: {
      flex: '1 1 400px'
    },
    curriculumRight: {
      flex: '1 1 400px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    curriculumImage: {
      maxWidth: '100%',
      height: 'auto'
    },
    curriculumList: {
      listStyle: 'none',
      padding: 0,
      margin: 0
    },
    curriculumItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '10px 0',
      borderBottom: '1px solid #f0f0f0',
      transition: 'transform 0.3s ease'
    },
    curriculumItemHover: {
      transform: 'translateX(10px)'
    },
    curriculumIcon: {
      marginRight: '10px',
      color: '#8b1650'
    },
    
    // Academic categories
    academicCategoriesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: '20px'
    },
    categoryCard: {
      position: 'relative',
      borderRadius: '4px',
      overflow: 'hidden',
      height: '250px',
      transition: 'transform 0.3s ease'
    },
    categoryCardHover: {
      transform: 'scale(1.03)'
    },
    categoryImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    categoryOverlay: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#8b1650',
      color: 'white',
      padding: '15px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    categoryTitle: {
      fontWeight: 'bold',
      fontSize: '18px'
    },
    
    // Skill development section
    skillDevSection: {
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${skillsbg})`,

      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: 'white',
      padding: '80px 0'
    },
    skillDevContainer: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    skillDevInfo: {
      flex: '1 1 300px',
      padding: '20px'
    },
    skillDevTitle: {
      fontSize: '40px',
      fontWeight: 'bold',
      marginBottom: '10px',
      color: 'white'
    },
    skillDevSubtitle: {
      fontSize: '20px',
      marginBottom: '40px'
    },
    skillDevGrid: {
      flex: '2 1 600px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
      gap: '20px'
    },
    skillDevCard: {
      backgroundColor: '#8b1650',
      padding: '30px 20px',
      borderRadius: '4px',
      textAlign: 'center',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease'
    },
    skillDevCardHover: {
      transform: 'translateY(-10px)',
      boxShadow: '0 15px 30px rgba(0, 0, 0, 0.2)'
    },
    
    // NEP section
    nepSection: {
      backgroundColor: '#f9f9f9',
      padding: '60px 0'
    },
    nepContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 2fr',
      gap: '30px',
      alignItems: 'center'
    },
    nepInfo: {
      backgroundColor: '#8b1650',
      color: 'white',
      padding: '40px',
      borderRadius: '4px',
      height: '100%'
    },
    nepTitle: {
      fontSize: '36px',
      fontWeight: 'bold',
      marginBottom: '10px'
    },
    nepSubtitle: {
      fontSize: '24px',
      marginBottom: '10px'
    },
    nepHighlight: {
      color: '#ffd700',
      fontSize: '32px',
      fontWeight: 'bold'
    },
    nepBenefitsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '20px'
    },
    nepBenefitCard: {
      backgroundColor: 'white',
      borderRadius: '4px',
      padding: '20px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      transition: 'transform 0.3s ease'
    },
    nepBenefitCardHover: {
      transform: 'translateY(-5px)'
    },
    nepBenefitIcon: {
      fontSize: '32px',
      marginBottom: '15px'
    },
    
    // Alumni section
    alumniSection: {
      padding: '60px 0',
      backgroundColor: 'white'
    },
    alumniSlider: {
      position: 'relative',
      padding: '20px 40px'
    },
    alumniSliderContent: {
      display: 'flex',
      overflowX: 'hidden',
      gap: '20px',
      padding: '20px 0',
      transition: 'transform 0.5s ease'
    },
    alumniCard: {
      minWidth: '200px',
      textAlign: 'center',
      transition: 'transform 0.3s ease'
    },
    alumniCardHover: {
      transform: 'scale(1.05)'
    },
    alumniImage: {
      width: '100%',
      height: '250px',
      objectFit: 'cover',
      borderRadius: '4px',
      marginBottom: '10px'
    },
    alumniName: {
      fontWeight: 'bold'
    },
    alumniControls: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 10px',
      pointerEvents: 'none'
    },
    alumniButton: {
      backgroundColor: '#8b1650',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      pointerEvents: 'all'
    },
    alumniButtonHover: {
      backgroundColor: '#6a1039'
    },
    alumniJoinButton: {
      display: 'block',
      margin: '30px auto 0',
      padding: '12px 25px',
      backgroundColor: '#8b1650',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease'
    },
    
    // Facts section
    factsSection: {
      padding: '60px 0',
      backgroundColor: '#f5f5f5'
    },
    factsSlider: {
      position: 'relative',
      padding: '20px 40px'
    },
    factsSliderContent: {
      display: 'flex',
      overflowX: 'hidden',
      gap: '20px',
      padding: '20px 0',
      transition: 'transform 0.5s ease'
    },
    factCard: {
      minWidth: '300px',
      padding:'30px',
      textAlign: 'center',
      backgroundColor: 'white',
      borderRadius: '4px',
      overflow: 'hidden',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s ease'
    },
    factCardHover: {
      transform: 'translateY(-5px)'
    },
    factImage: {
      width: '80%',
      height: '180px',
      objectFit: 'cover'
    },
    factTitle: {
      padding: '15px',
      fontWeight: 'bold'
    },
    
    // News section
    newsSection: {
      padding: '60px 0'
    },
    newsTabs: {
      display: 'flex',
      borderBottom: '1px solid #e0e0e0',
      marginBottom: '20px'
    },
    newsTab: {
      padding: '10px 20px',
      cursor: 'pointer',
      borderBottom: '2px solid transparent',
      transition: 'all 0.3s ease'
    },
    newsTabActive: {
      borderBottomColor: '#8b1650',
      color: '#8b1650',
      fontWeight: 'bold'
    },
    newsContent: {
      marginTop: '20px'
    },
    newsItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '15px 0',
      borderBottom: '1px solid #f0f0f0'
    },
    newsDate: {
      backgroundColor: '#f0f0f0',
      padding: '10px',
      textAlign: 'center',
      minWidth: '60px',
      marginRight: '20px'
    },
    newsMonth: {
      fontWeight: 'bold',
      fontSize: '14px'
    },
    newsDay: {
      fontSize: '18px',
      fontWeight: 'bold'
    },
    newsTitle: {
      flex: 1
    },
    newsNew: {
      backgroundColor: '#ff0000',
      color: 'white',
      padding: '2px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      marginLeft: '10px'
    },
    
    // Leadership section
    leadershipSection: {
      padding: '60px 0',
      backgroundColor: '#f9f9f9'
    },
    leadershipGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '30px'
    },
    leaderCard: {
      backgroundColor: 'white',
      borderRadius: '4px',
      overflow: 'hidden',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s ease'
    },
    leaderCardHover: {
      transform: 'translateY(-5px)'
    },
    leaderImage: {
      width: '100%',
      height: '200px',
      objectFit: 'cover'
    },
    leaderInfo: {
      padding: '20px'
    },
    leaderName: {
      fontWeight: 'bold',
      fontSize: '18px',
      marginBottom: '5px'
    },
    leaderTitle: {
      color: '#8b1650',
      marginBottom: '10px'
    },
    leaderLink: {
      color: '#8b1650',
      textDecoration: 'none',
      fontWeight: 'bold'
    },
    
    // Colleges section
    collegesSection: {
      padding: '60px 0'
    },
    collegesTitle: {
      fontSize: '28px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '30px'
    },
    collegesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
      gap: '20px'
    },
    collegeCard: {
      textAlign: 'center',
      padding: '20px',
      borderRadius: '4px',
      backgroundColor: 'white',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s ease'
    },
    collegeCardHover: {
      transform: 'translateY(-5px)'
    },
    collegeLogo: {
      width: '80px',
      height: '80px',
      margin: '0 auto 15px'
    },
    collegeName: {
      fontSize: '14px',
      fontWeight: 'bold'
    },
    
    // Footer styles
    footer: {
      backgroundColor: '#8b1650',
      color: 'white',
      padding: '60px 0 20px'
    },
    footerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '30px'
    },
    footerLogo: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '20px'
    },
    footerLogoImage: {
      height: '50px',
      width: 'auto'
    },
    footerLogoText: {
      fontSize: '20px',
      fontWeight: 'bold'
    },
    footerTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '20px',
      borderBottom: '2px solid rgba(255, 255, 255, 0.2)',
      paddingBottom: '10px'
    },
    footerLink: {
      color: 'white',
      textDecoration: 'none',
      display: 'block',
      marginBottom: '10px',
      transition: 'color 0.3s ease'
    },
    footerLinkHover: {
      color: '#ffd700'
    },
    footerBottom: {
      borderTop: '1px solid rgba(255, 255, 255, 0.2)',
      marginTop: '40px',
      paddingTop: '20px',
      textAlign: 'center'
    },
    socialIcons: {
      display: 'flex',
      gap: '15px',
      marginTop: '20px'
    },
    socialIcon: {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background-color 0.3s ease'
    },
    socialIconHover: {
      backgroundColor: 'rgba(255, 255, 255, 0.4)'
    },
    
    // Back to top button
    backToTop: {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      width: '50px',
      height: '50px',
      backgroundColor: '#ffd700',
      color: '#8b1650',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
      opacity: 0,
      transition: 'opacity 0.3s ease, transform 0.3s ease',
      fontSize: '24px',
      fontWeight: 'bold',
      zIndex: 100
    },
    backToTopVisible: {
      opacity: 1,
      transform: 'translateY(0)'
    },
    backToTopHidden: {
      opacity: 0,
      transform: 'translateY(20px)'
    },
    
    // Animation classes
    fadeIn: {
      animation: 'fadeIn 1s ease forwards'
    },
    fadeInUp: {
      animation: 'fadeInUp 1s ease forwards'
    },
    fadeInLeft: {
      animation: 'fadeInLeft 1s ease forwards'
    },
    fadeInRight: {
      animation: 'fadeInRight 1s ease forwards'
    },
    
    // Responsive styles
    '@media (max-width: 768px)': {
      mobileMenuButton: {
        display: 'block'
      },
      nav: {
        display: 'none'
      },
      mobileMenu: {
        display: mobileMenuOpen ? 'block' : 'none'
      },
      nepContainer: {
        gridTemplateColumns: '1fr'
      },
      nepBenefitsGrid: {
        gridTemplateColumns: '1fr'
      },
      skillDevContainer: {
        flexDirection: 'column'
      },
      skillDevGrid: {
        gridTemplateColumns: 'repeat(2, 1fr)'
      }
    },
    '@media (max-width: 576px)': {
      skillDevGrid: {
        gridTemplateColumns: '1fr'
      },
      academicCategoriesGrid: {
        gridTemplateColumns: '1fr'
      },
      featuresGrid: {
        gridTemplateColumns: '1fr'
      }
    }
  };

  // Animation keyframes
  const keyframes = `
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    
    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(30px); }
      to { opacity: 1; transform: translateY(0); }
    }
    
    @keyframes fadeInLeft {
      from { opacity: 0; transform: translateX(-30px); }
      to { opacity: 1; transform: translateX(0); }
    }
    
    @keyframes fadeInRight {
      from { opacity: 0; transform: translateX(30px); }
      to { opacity: 1; transform: translateX(0); }
    }
    
    @keyframes ticker {
      0% { transform: translateX(0); }
      100% { transform: translateX(-100%); }
    }
  `;

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Handle alumni slider navigation
  const handleAlumniNav = (direction) => {
    if (direction === 'prev') {
      setCurrentAlumniPage(prev => (prev > 0 ? prev - 1 : 0));
    } else {
      const maxPages = Math.ceil(alumni.length / 5) - 1;
      setCurrentAlumniPage(prev => (prev < maxPages ? prev + 1 : maxPages));
    }
  };

  // Handle facts slider navigation
  const handleFactsNav = (direction) => {
    if (direction === 'prev') {
      setCurrentFactsPage(prev => (prev > 0 ? prev - 1 : 0));
    } else {
      const maxPages = Math.ceil(facts.length / 3) - 1;
      setCurrentFactsPage(prev => (prev < maxPages ? prev + 1 : maxPages));
    }
  };


  return (
    <div style={styles.body}>
      {/* Add keyframes for animations */}
      <style>{keyframes}</style>
      
      {/* Top Bar */}
      <div style={styles.topBar}>
        <div style={{...styles.container, ...styles.topBarContent}}>
          <div style={styles.topBarLeft}>
          <span>{new Date().toLocaleDateString('en-GB', {
  weekday: 'long',
  day: '2-digit',
  month: 'long',
  year: 'numeric'
})}</span>

            <span style={{margin: '0 15px'}}>|</span>
            <a href="#" style={{color: '#333', textDecoration: 'none'}}>Sitemap</a>
            <span style={{margin: '0 15px'}}>|</span>
            <a href="#" style={{color: '#333', textDecoration: 'none'}}>Screen Reader</a>
          </div>
          <div style={styles.topBarRight}>
          <a href="#main-content" style={{color: '#333', textDecoration: 'none'}}>Skip To Main Content</a>

            <div>
              <button style={{background: 'none', border: 'none', cursor: 'pointer'}}>A+</button>
              <button style={{background: '#8b1650', color: 'white', border: 'none', padding: '0 5px', cursor: 'pointer'}}>A</button>
              <button style={{background: 'none', border: 'none', cursor: 'pointer'}}>A-</button>
            </div>
          </div>
        </div>
      </div>
      
       <header id="main-content" style={styles.header}>
      <div style={{ ...styles.headerContent }}>
        <div style={styles.logo}>
          <img 
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/hbsu-FnQmbpV8mHCF6qu4hA65O07SdtFUJ3.png" 
            alt="HBSU Logo" 
            style={styles.logoImage} 
          />
          
          <div style={styles.logoText}>
            <div>Dr. Homi Bhabha</div>
            <div>State University</div>
          </div>

          <img 
            src={TdtlLogo}
            alt="TDTL Logo" 
            style={styles.logoImage} 
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', height: 'auto', gap: '10px' }}>
          <img src={logog20} alt="G20" style={{ height: windowWidth < 600 ? '40px' : '80px' }} />
          <img src={logogov} alt="Government of Maharashtra" style={{ height: windowWidth < 600 ? '40px' : '80px' }} />
        </div>

        <button 
          style={styles.mobileMenuButton} 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>
    </header>

      {/* News Ticker */}
      <div style={styles.newsTicker}>
  <div style={{...styles.container, ...styles.newsTickerContent}}>
    <div style={styles.newsTickerLabel}>Latest News:</div>
    
    {/* ✅ Scrolling container */}
    <div style={styles.newsTickerScrollWrapper}>
      <div style={styles.newsTickerItems(isTickerPaused)}>
        {[
          "M.Sc. Biotechnology Admission Entrance Test will be conducted on 8th April 2025 at 12.00 noon.",
          "Ph.D. (Interdisciplinary Studies) subject of Education, 2025-26",
          "List of Selected Students for Ph.D.(Science) 2025-26",
          "Enroll To Our Courses - Agentic AI & GenAI Accelerator",
          "AI in Action: GenAI & Agentic AI Work-Study Program",
          "AI Masters: GenAI & Intelligent Agents Internship Program",
          "Applied AI Accelerator: Cloud, ML & DL",
          "AI Architect Program: Cloud, ML & DL Work-Integrated Fellowship",
          "Data Analytics Accelerator: Cloud, AI & ML for Decision-Making",
          "AI-Driven Data Analytics: Work-Integrated Learnin",
        ].map((text, index) => (
          <div key={index} style={styles.newsTickerItem}>
            {text}
            <span style={{...styles.newsNew, marginLeft: '10px'}}>New</span>
          </div>
        ))}
      </div>
    </div>

    <div style={styles.newsTickerControls}>
  <button 
    style={styles.newsTickerControl} 
    onClick={() => setActiveSlide(prev => (prev > 0 ? prev - 1 : 2))}
  >
    ❮
  </button>

  <button 
    style={styles.newsTickerControl} 
    onClick={() => setIsTickerPaused(prev => !prev)}
  >
    {isTickerPaused ? '▶' : '❚❚'}
  </button>

  <button 
    style={styles.newsTickerControl} 
    onClick={() => setActiveSlide(prev => (prev < 2 ? prev + 1 : 0))}
  >
    ❯
  </button>
</div>

  </div>
</div>

      
      {/* Hero Slider */}
 

<div style={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
      {/* Image Slider */}
      <div
        style={{
          display: 'flex',
          width: '100%',
          transform: `translateX(-${index * 100}%)`,
          transition: transition ? "transform 1s ease-in-out" : "none",
        }}
      >
        {extendedImages.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`Slide ${i}`}
            style={{
              minWidth: '100%',
              objectFit: 'cover',
              height: '100vh',
            }}
          />
        ))}
      </div>

      {/* Overlay Content */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark overlay effect
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        zIndex: 1,
      }}>
        <div style={{
          textAlign: 'center',
          padding: '20px',
        }}>
          <h1 style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            marginBottom: '20px',
          }}>
            Welcome to Dr. Homi Bhabha State University
          </h1>
          <p style={{
            fontSize: '1.25rem',
            marginBottom: '30px',
          }}>
            Empowering minds, shaping futures
          </p>
          <Link to="/ProgramCards" style={{
            display: 'inline-block',
            padding: '12px 24px',
            backgroundColor: '#ff6600',
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 'bold',
            textDecoration: 'none',
            borderRadius: '5px',
            transition: 'background-color 0.3s ease',
          }}>
            Certificate Course Registration Form 2025-2026
          </Link>
             {/* <Link
              to="/AdmissionEnquiryForm"
              style={{
                display: "inline-block",
                padding: "12px 24px",
                backgroundColor: "#ff6600",
                color: "#fff",
                fontSize: "1rem",
                fontWeight: "bold",
                textDecoration: "none",
                borderRadius: "5px",
                transition: "background-color 0.3s ease",
                marginLeft:"12px",
              }}
            >
              Course Enquiry
            </Link> */}
        </div>
      </div>
    </div>

      {/* Facts & Honours Section */}
      <section style={{ padding: '60px 0', backgroundColor: '#f5f5f5' }}>
  <div style={{
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 15px',
    width: '100%'
  }}>
    <h2 style={{
      color: '#8b1650',
      fontSize: '32px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '30px'
    }}>
      Facts & Honours
    </h2>

    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      justifyContent: 'center'
    }}>
      {facts.map((fact, index) => (
        <div
          key={fact.id}
          style={{
            backgroundColor: 'white',
            borderRadius: '4px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
            overflow: 'hidden',
            transition: 'transform 0.3s ease',
            minWidth: '260px',
            maxWidth: '100%',
            flex: '1 1 300px'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <img
            src={fact.image || "/placeholder.svg"}
            alt={fact.title}
            style={{
              padding:'30px',
              width: '80%',
              height: '200px',
              objectFit: 'cover'
            }}
          />
          <div style={{
            padding: '15px',
            fontWeight: 'bold'
          }}>
            {fact.title}
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
<Aboutus/>
      
 {/* Video Tour Section */}
<section style={{ padding: "40px 0" }}>
  <div style={styles.container}>
    <h2 style={styles.sectionTitle}>Video Tour</h2>
    <div style={{ maxWidth: "800px", margin: "0 auto", aspectRatio: "16/9", backgroundColor: "#000" }}>
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/-Zh0PQwSQ0w"
        title="YouTube Video Tour"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ borderRadius: "10px" }}
      ></iframe>
    </div>
  </div>
</section>

      
      {/* News & Notices Section */}
      <section style={{ padding: "60px 0", backgroundColor: "#f9f9f9" }}>
  <div style={{
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 15px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '30px'
  }}>
    {/* News & Notices Section (Left) */}
    <div style={{
      flex: '1 1 60%',
      minWidth: '300px'
    }}>
      <h2 style={{
        color: '#8b1650',
        fontSize: '28px',
        fontWeight: 'bold',
        marginBottom: '20px'
      }}>News & Notices</h2>

      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {['Students', 'Placements', 'Admissions', 'Advertisements'].map(tab => (
            <div
              key={tab}
              onClick={() => setActiveNewsTab(tab)}
              style={{
                padding: '10px 20px',
                cursor: 'pointer',
                borderBottom: activeNewsTab === tab ? '2px solid #8b1650' : '2px solid transparent',
                fontWeight: activeNewsTab === tab ? 'bold' : 'normal',
                color: activeNewsTab === tab ? '#8b1650' : '#333'
              }}
            >
              {tab}
            </div>
          ))}
        </div>
       
      </div>

      <div>
        {activeNewsTab === 'Students' && newsItems.map((item, index) => (
          <div key={index} style={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px 0',
            borderBottom: '1px solid #eee'
          }}>
            <div style={{
              backgroundColor: '#f0f0f0',
              padding: '10px',
              textAlign: 'center',
              minWidth: '60px',
              marginRight: '15px'
            }}>
              <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{item.date.split(' ')[0]}</div>
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{item.date.split(' ')[1]}</div>
            </div>
            <div style={{ flex: 1 }}>
              <a href={item.link} style={{ textDecoration: 'none', color: '#333', fontWeight: '500' }}>
                {item.title}
                {item.isNew && <span style={{
                  backgroundColor: '#ff0000',
                  color: 'white',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  marginLeft: '10px'
                }}>New</span>}
              </a>
              <a href="#" style={{ color: '#8b1650', textDecoration: 'none', fontSize: '13px', display: 'block' }}>Download</a>
            </div>
          </div>
        ))}
        {activeNewsTab !== 'Students' && (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>{activeNewsTab} information will be updated soon.</p>
          </div>
        )}
      </div>
    </div>

    {/* Leadership Section (Right, Vertical Cards) */}
    <div style={{
  flex: '1 1 35%',
  minWidth: '280px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px'
}}>
  <h2 style={{
    color: '#8b1650',
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '10px'
  }}>Leadership</h2>

  {leadership.map((leader, index) => (
    <div
      key={index}
      style={{
        backgroundColor: 'white',
        borderRadius: '6px',
        overflow: 'hidden',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '15px',
        padding: '15px'
      }}
      onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
      onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
    >
      <img
        src={leader.image || "/placeholder.svg"}
        alt={leader.name}
        style={{
          width: '100px',
          height: '100px',
          objectFit: 'cover',
          borderRadius: '6px'
        }}
      />
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px', fontSize: '16px' }}>{leader.name}</div>
        <div style={{ color: '#8b1650', marginBottom: '10px', fontSize: '14px' }}>{leader.title}</div>
        <a href="#" style={{ color: '#8b1650', fontWeight: 'bold', fontSize: '14px', textDecoration: 'none' }}>View Profile</a>
      </div>
    </div>
  ))}
</div>

  </div>
</section>


      {/* Features Section */}
      <section style={styles.section} ref={featuresRef}>
        <div style={styles.container}>
          <h2 style={styles.sectionTitle}>Features</h2>
          <div 
            style={styles.featuresGrid}
            className={isVisible.features ? 'animated' : ''}
          >
            {features.map((feature, index) => (
              <div 
                key={feature.id}
                style={{
                  ...styles.featureCard,
                  ...(isVisible.features && { animation: `fadeIn 0.5s ease ${index * 0.1}s forwards`, opacity: 0 })
                }}
                onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
              >
                <img src={feature.image || "/placeholder.svg"} alt={feature.title} style={styles.featureImage} />
                <div style={styles.featureTitle}>{feature.title}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Partnerships Section */}
      <section style={styles.section} ref={partnershipsRef}>
        <div style={styles.container}>
          <h2 style={styles.sectionTitle}>Partnerships & Participations</h2>
          <div 
            style={styles.partnersGrid}
            className={isVisible.partnerships ? 'animated' : ''}
          >
            {partners.map((partner, index) => (
              <div 
                key={partner.id}
                style={{
                  transition: 'transform 0.3s ease',
                  ...(isVisible.partnerships && { animation: `fadeIn 0.5s ease ${index * 0.1}s forwards`, opacity: 0 })
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              >
                <img src={partner.logo || "/placeholder.svg"} alt="Partner logo" style={styles.partnerLogo} />
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Curriculum Section */}
      <section style={styles.section} ref={curriculumRef}>
        <div style={styles.container}>
          <h2 style={styles.sectionTitle}>Enriched Curriculum</h2>
          <div style={styles.curriculumContainer}>
            <p 
              style={{
                ...styles.curriculumDescription,
                ...(isVisible.curriculum && styles.fadeIn)
              }}
            >
              An enriched curriculum in a university typically goes beyond the basic academic requirements and offers additional components that enhance the overall learning experience.
            </p>
            <div style={styles.curriculumContent}>
              <div 
                style={{
                  ...styles.curriculumLeft,
                  ...(isVisible.curriculum && styles.fadeInLeft)
                }}
              >
                <ul style={styles.curriculumList}>
                  {curriculumItems.slice(0, 8).map((item, index) => (
                    <li 
                      key={index}
                      style={styles.curriculumItem}
                      onMouseEnter={(e) => e.target.style.transform = 'translateX(10px)'}
                      onMouseLeave={(e) => e.target.style.transform = 'translateX(0)'}
                    >
                      <span style={styles.curriculumIcon}>{item.icon}</span>
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div 
                style={{
                  ...styles.curriculumRight,
                  ...(isVisible.curriculum && styles.fadeInRight)
                }}
              >
                <img 
                  src={tree} 
                  alt="Knowledge Tree" 
                  style={styles.curriculumImage} 
                />
              </div>
              <div 
                style={{
                  ...styles.curriculumLeft,
                  ...(isVisible.curriculum && styles.fadeInLeft)
                }}
              >
                <ul style={styles.curriculumList}>
                  {curriculumItems.slice(8).map((item, index) => (
                    <li 
                      key={index}
                      style={styles.curriculumItem}
                      onMouseEnter={(e) => e.target.style.transform = 'translateX(10px)'}
                      onMouseLeave={(e) => e.target.style.transform = 'translateX(0)'}
                    >
                      <span style={styles.curriculumIcon}>{item.icon}</span>
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Academic Categories Section */}
      <section style={styles.section} ref={academicsRef}>
        <div style={styles.container}>
          <div 
            style={styles.academicCategoriesGrid}
            className={isVisible.academics ? 'animated' : ''}
          >
            {academicCategories.map((category, index) => (
              <div 
                key={category.id}
                style={{
                  ...styles.categoryCard,
                  ...(isVisible.academics && { animation: `fadeIn 0.5s ease ${index * 0.2}s forwards`, opacity: 0 })
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.03)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              >
                <img src={category.image || "/placeholder.svg"} alt={category.title} style={styles.categoryImage} />
                <div style={styles.categoryOverlay}>
                  <div style={styles.categoryTitle}>{category.title}</div>
                  <div style={{ color: 'white' }}>→</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Skill Development Section */}
      <section style={styles.skillDevSection} ref={skillsRef}>
        <div style={styles.container}>
          <div style={styles.skillDevContainer}>
            <div 
              style={{
                ...styles.skillDevInfo,
                ...(isVisible.skills && styles.fadeInLeft)
              }}
            >
              <h2 style={styles.skillDevTitle}>Skill Development Center</h2>
              <p style={styles.skillDevSubtitle}>For Holistic Development</p>
            </div>
            
            <div 
              style={{
                ...styles.skillDevGrid,
                ...(isVisible.skills && styles.fadeInRight)
              }}
            >
              {skillDevelopment.map((skill, index) => (
                <div 
                  key={skill.id}
                  style={{
                    ...styles.skillDevCard,
                    ...(isVisible.skills && { animation: `fadeIn 0.5s ease ${index * 0.1}s forwards`, opacity: 0 })
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'translateY(-10px)'}
                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  <h3>{skill.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      {/* NEP Section */}
      <section style={styles.nepSection} ref={nepRef}>
        <div style={styles.container}>
          <div 
            style={{
              ...styles.nepContainer,
              ...(isVisible.nep && styles.fadeIn)
            }}
          >
            <div style={styles.nepInfo}>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <img src={nepnewlogo} alt="NEP Logo" />
              </div>
              <h3 style={styles.nepTitle}>HBSU Is Now</h3>
              <h3 style={styles.nepSubtitle}>A 100%</h3>
              <h2 style={styles.nepHighlight}>NEP 2020</h2>
              <h3 style={styles.nepSubtitle}>Compliant University</h3>
            </div>
            
            <div style={styles.nepBenefitsGrid}>
              {nepBenefits.map((benefit, index) => (
                <div 
                  key={benefit.id}
                  style={{
                    ...styles.nepBenefitCard,
                    ...(isVisible.nep && { animation: `fadeIn 0.5s ease ${index * 0.1}s forwards`, opacity: 0 })
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  <div style={styles.nepBenefitIcon}>{benefit.icon}</div>
                  <div>{benefit.title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      {/* Alumni Section */}
      <section style={styles.alumniSection} ref={alumniRef}>
        <div style={styles.container}>
          <h2 style={styles.sectionTitle}>Eminent Alumni of HBSU</h2>
          
          <div style={styles.alumniSlider}>
            <div 
              style={{
                ...styles.alumniSliderContent,
                transform: `translateX(-${currentAlumniPage * 220}px)`
              }}
            >
              {alumni.map((person, index) => (
                <div 
                  key={person.id}
                  style={{
                    ...styles.alumniCard,
                    ...(isVisible.alumni && { animation: `fadeIn 0.5s ease ${index * 0.1}s forwards`, opacity: 0 })
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                >
                  <img src={person.image || "/placeholder.svg"} alt={person.name} style={styles.alumniImage} />
                  <div style={styles.alumniName}>{person.name}</div>
                </div>
              ))}
            </div>
            
            <div style={styles.alumniControls}>
              <button 
                style={{
                  ...styles.alumniButton,
                  opacity: currentAlumniPage === 0 ? 0.5 : 1,
                  cursor: currentAlumniPage === 0 ? 'default' : 'pointer'
                }}
                onClick={() => handleAlumniNav('prev')}
                disabled={currentAlumniPage === 0}
              >
                ❮
              </button>
              <button 
                style={{
                  ...styles.alumniButton,
                  opacity: currentAlumniPage >= Math.ceil(alumni.length / 5) - 1 ? 0.5 : 1,
                  cursor: currentAlumniPage >= Math.ceil(alumni.length / 5) - 1 ? 'default' : 'pointer'
                }}
                onClick={() => handleAlumniNav('next')}
                disabled={currentAlumniPage >= Math.ceil(alumni.length / 5) - 1}
              >
                ❯
              </button>
            </div>
          </div>
          
          <button style={styles.alumniJoinButton}>CLICK HERE TO BECOME A PART OF HBSU ALUMNI</button>
        </div>
      </section>
      <Contactus/>
      
      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.container}>
          <div style={styles.footerGrid}>
            <div>
              <div style={styles.footerLogo}>
                <img src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/hbsu-FnQmbpV8mHCF6qu4hA65O07SdtFUJ3.png" alt="HBSU Logo" style={styles.footerLogoImage} />
                <div style={styles.footerLogoText}>HBSU</div>
              </div>
              <p>Dr. Homi Bhabha State University - Shaping minds, building futures.</p>
              <div style={styles.socialIcons}>
                <a 
                  href="#" 
                  style={styles.socialIcon}
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.4)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                >
                  in
                </a>
                <a 
                  href="#" 
                  style={styles.socialIcon}
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.4)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                >
                  f
                </a>
                <a 
                  href="#" 
                  style={styles.socialIcon}
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.4)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                >
                  t
                </a>
              </div>
            </div>
            
            <div>
              <h3 style={styles.footerTitle}>Contact Us</h3>
              <p>
                <strong>Dr. Homi Bhabha State University</strong><br />
                15, Madam Cama Road,<br />
                Mumbai - 400032
              </p>
              <p>
                <strong>Phone:</strong> 022-35136751<br />
                <strong>Email:</strong> info@hbsu.ac.in
              </p>
            </div>
            
            <div>
              <h3 style={styles.footerTitle}>Constituent Colleges</h3>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '10px' }}>➤ Institute Of Science, Mumbai</li>
                <li style={{ marginBottom: '10px' }}>➤ Elphinstone College, Mumbai</li>
                <li style={{ marginBottom: '10px' }}>➤ Sydenham College, Mumbai</li>
                <li style={{ marginBottom: '10px' }}>➤ Secondary Training College, Mumbai</li>
                <li style={{ marginBottom: '10px' }}>➤ SIMSREE</li>
                <li style={{ marginBottom: '10px' }}>➤ Institute Of Forensic Science</li>
              </ul>
            </div>
            
            <div>
              <h3 style={styles.footerTitle}>Working Hours</h3>
              <p>10:00 AM To 6:00 PM</p>
              
              <h3 style={{ ...styles.footerTitle, marginTop: '30px' }}>Site Visitors</h3>
              <div style={{ fontSize: '24px', letterSpacing: '10px' }}>36735</div>
            </div>
          </div>
          
          <div style={styles.footerBottom}>
            <p>© HBSU | Powered by WhiteCode</p>
          </div>
        </div>
      </footer>



{showPopup && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
    zIndex: 2000
  }}>
    <div style={{
      backgroundColor: 'white',
      width: '100%',
      maxWidth: '500px',
      padding: window.innerWidth < 480 ? '20px' : '30px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
      textAlign: 'center',
      position: 'relative',
      margin: '0 10px'
    }}>
      <button
        onClick={() => setShowPopup(false)}
        style={{
          position: 'absolute',
          top: '10px',
          right: '15px',
          background: 'none',
          border: 'none',
          fontSize: window.innerWidth < 480 ? '18px' : '22px',
          cursor: 'pointer'
        }}
      >
        ×
      </button>
      <button
        onClick={() => navigate('/ProgramCards')}
        style={{
          width: '100%',
          padding: window.innerWidth < 480 ? '12px 20px' : '15px 30px',
          backgroundColor: '#ff6600',
          color: '#fff',
          fontWeight: 'bold',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: window.innerWidth < 480 ? '14px' : '16px',
          marginBottom: '10px'
        }}
      >
        Certificate Course Registration Form 2025-2026
      </button>
      
<button
  onClick={() => window.open('https://hbsu.digitaledu.in/modules/Candidate/candidateLogin.php', '_blank')}
  style={{
    width: '100%',
    padding: window.innerWidth < 480 ? '12px 20px' : '15px 30px',
    backgroundColor: '#4b0d2d',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: window.innerWidth < 480 ? '14px' : '16px',
  }}
>
  Admission Registration Form, 2025-26
</button>


    </div>
  </div>
)}

      {/* Back to Top Button */}
      <div 
        style={{
          ...styles.backToTop,
          ...(scrollY > 300 ? styles.backToTopVisible : styles.backToTopHidden)
        }}
        onClick={scrollToTop}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#e6c200'}
        onMouseLeave={(e) => e.target.style.backgroundColor = '#ffd700'}
      >
        ↑
      </div>
    </div>
  );
}

export default App;